import { Activity, XCircle, RefreshCw } from "lucide-react";

export default function PipelineStatusPanel({ pipelineStatus, onRetryErrors, onClearQueue }) {
  if (!pipelineStatus) return null;

  return (
    <div className="mt-4 rounded-lg border" data-testid="pipeline-status-panel"
      style={{ backgroundColor: "#161b22", borderColor: "#30363d" }}>
      <div className="flex items-center justify-between px-4 py-3 border-b" style={{ borderColor: "#30363d" }}>
        <div className="flex items-center gap-2">
          <Activity size={14} style={{ color: pipelineStatus.queue.total_queued > 0 ? "#f59e0b" : "#22c55e" }} />
          <span className="font-mono text-[10px] tracking-[0.12em] uppercase font-semibold"
            style={{ color: pipelineStatus.queue.total_queued > 0 ? "#f59e0b" : "#22c55e" }}>
            PIPELINE STATUS
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={onRetryErrors} data-testid="pipeline-retry-btn"
            className="px-2 py-1 rounded font-mono text-[9px] transition-colors hover:brightness-110"
            style={{ color: "#f59e0b", border: "1px solid rgba(245,158,11,0.3)", backgroundColor: "rgba(245,158,11,0.06)" }}>
            RETRY ERRORS
          </button>
          <button onClick={onClearQueue} data-testid="pipeline-clear-btn"
            className="px-2 py-1 rounded font-mono text-[9px] transition-colors hover:brightness-110"
            style={{ color: "#ef4444", border: "1px solid rgba(239,68,68,0.3)", backgroundColor: "rgba(239,68,68,0.06)" }}>
            CLEAR QUEUE
          </button>
        </div>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
          <PipelineMetric
            value={pipelineStatus.queue.pending}
            label="PENDING"
            color={pipelineStatus.queue.pending > 4 ? "#ef4444" : pipelineStatus.queue.pending > 0 ? "#f59e0b" : "#22c55e"}
          />
          <PipelineMetric
            value={pipelineStatus.queue.analyzing}
            label="ANALYZING"
            color={pipelineStatus.queue.analyzing > 0 ? "#3b82f6" : "#8b949e"}
          />
          <PipelineMetric
            value={pipelineStatus.throughput.last_5m}
            label="LAST 5 MIN"
            color="#8b949e"
          />
          <PipelineMetric
            value={pipelineStatus.throughput.avg_latency_ms ? `${(pipelineStatus.throughput.avg_latency_ms / 1000).toFixed(1)}s` : "\u2014"}
            label="AVG LATENCY"
            color="#8b949e"
          />
        </div>

        {/* Currently analyzing */}
        {pipelineStatus.queue.currently_analyzing && (
          <div className="mb-3 p-2 rounded" style={{ backgroundColor: "rgba(59,130,246,0.06)", border: "1px solid rgba(59,130,246,0.15)" }}>
            <span className="font-mono text-[10px]" style={{ color: "#3b82f6" }}>ANALYZING: </span>
            <span className="font-mono text-[10px]" style={{ color: "#8b949e" }}>
              @{pipelineStatus.queue.currently_analyzing.source} \u2014 {pipelineStatus.queue.currently_analyzing.elapsed_seconds}s elapsed
            </span>
          </div>
        )}

        {/* Errors */}
        {pipelineStatus.errors.count_last_hour > 0 && (
          <div>
            <div className="font-mono text-[9px] mb-1 tracking-wider" style={{ color: "#ef4444" }}>
              ERRORS ({pipelineStatus.errors.count_last_hour})
            </div>
            {pipelineStatus.errors.details.map((err, i) => (
              <div key={`err-${err.source}-${i}`} className="flex items-start gap-2 mb-1">
                <XCircle size={10} className="shrink-0 mt-0.5" style={{ color: "#ef4444" }} />
                <span className="font-mono text-[10px]" style={{ color: "#8b949e" }}>
                  @{err.source}: {err.error?.slice(0, 60)} \u2014 {err.text_preview?.slice(0, 40)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function PipelineMetric({ value, label, color }) {
  return (
    <div className="text-center">
      <div className="font-mono text-xl font-bold" style={{ color }}>
        {value}
      </div>
      <div className="font-mono text-[9px]" style={{ color: "#484f58" }}>{label}</div>
    </div>
  );
}
